module.exports = __webpack_public_path__ + "static/img/icon_acc.3a9691de.svg";